import PropTypes from 'prop-types';

import { SportType, TournamentType, MatchType, CategoryType } from '../../api/types';

export const BreadCrumbKeyType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

export const BreadCrumbType = PropTypes.exact({
  key: BreadCrumbKeyType,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  data: PropTypes.oneOfType([SportType, TournamentType, MatchType, CategoryType]).isRequired,
  breadCrumbType: PropTypes.string,
  isLive: PropTypes.bool,
});
